export default {
      id: "ic_hourglass_orange-usage",
      viewBox: "0 0 36 36",
      url: "/" + "images/icons.3.109.2.svg#ic_hourglass_orange-usage",
      toString: function () {
        return this.url;
      }
    }